import { convertPrice } from "./currency";

export function formatPrice(minorUnits: number, currency: string, displayCurrency?: string | null): string {
  const targetCurrency = displayCurrency && displayCurrency !== currency ? displayCurrency : currency;
  const value = displayCurrency && displayCurrency !== currency
    ? convertPrice(minorUnits, currency, displayCurrency)
    : minorUnits;
  try {
    return new Intl.NumberFormat("en-CH", {
      style: "currency",
      currency: targetCurrency,
      maximumFractionDigits: 0,
    }).format(value / 100);
  } catch {
    return `${targetCurrency} ${(value / 100).toFixed(0)}`;
  }
}

export function formatDate(d: Date | string): string {
  const date = typeof d === "string" ? new Date(d) : d;
  // Use LOCAL date parts, not toISOString(). Picking Nov 14 in a
  // GMT+2 timezone produced "2026-11-13" via toISOString() because
  // local midnight = 22:00 UTC the previous day. The date-range
  // picker returns calendar-local Date objects, so the YYYY-MM-DD
  // string should preserve that local calendar day.
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

const longFmt = new Intl.DateTimeFormat("en-GB", {
  month: "short",
  day: "numeric",
  year: "numeric",
});
const shortFmt = new Intl.DateTimeFormat("en-GB", {
  month: "short",
  day: "numeric",
});

export function formatDateLong(d: Date | string): string {
  const date = typeof d === "string" ? new Date(d) : d;
  return longFmt.format(date);
}

export function formatDateRange(start?: Date | string | null, end?: Date | string | null): string {
  if (!start || !end) return "";
  const s = typeof start === "string" ? new Date(start) : start;
  const e = typeof end === "string" ? new Date(end) : end;
  const sameYear = s.getFullYear() === e.getFullYear();
  const sameMonth = sameYear && s.getMonth() === e.getMonth();
  if (sameMonth) {
    return `${shortFmt.format(s)} – ${e.getDate()}, ${e.getFullYear()}`;
  }
  if (sameYear) {
    return `${shortFmt.format(s)} – ${shortFmt.format(e)}, ${e.getFullYear()}`;
  }
  return `${longFmt.format(s)} – ${longFmt.format(e)}`;
}

export function nightsBetween(checkIn: Date | string, checkOut: Date | string): number {
  const ci = typeof checkIn === "string" ? new Date(checkIn) : checkIn;
  const co = typeof checkOut === "string" ? new Date(checkOut) : checkOut;
  const ms = co.getTime() - ci.getTime();
  if (ms <= 0) return 0;
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}
